import React from "react";
import {render} from "react-dom";
import {Router, Route, IndexRoute, Link, browserHistory} from "react-router";
import IdentityAccessService from "./core/services/identityAccessService.js";

import "regenerator-runtime/runtime";
import "materialize-css/dist/js/materialize.js";
import "./materialize.scss";
import "!style!css!../src-epoch/epoch.css";
import "./simple-line-icons.scss";
import '!style!css!react-select/dist/react-select.css';

require("file?name=environment.js!./environment.js");

require("file?name=vendors/createjs.min.js!./vendors/createjs/createjs.min.js");
require("file?name=vendors/solclient.js!./vendors/solclientjs/lib/solclient.js");
require("file?name=vendors/three.min.js!./vendors/three.min.js");

require("file?name=resources/globe/blue-world-contrast.jpg!./resources/globe/blue-world-contrast.jpg");
require("file?name=resources/globe/bump.jpg!./resources/globe/bump.jpg");
require("file?name=resources/globe/earthquakes-2015.csv!./resources/globe/earthquakes-2015.csv");
require("file?name=resources/globe/crudeoil.json!./resources/globe/crudeoil.json");
require("file?name=img/cursor-hand.png!./img/cursor-hand.png");
require("file?name=./favicon.ico!./img/favicon.ico");
require("file?name=./logo.png!./img/smash-icon.png");

require("file?name=./worker.js!../src-client-lib/solace/worker.js");
require("file?name=./timer-worker.js!./core/timer-worker.js");
require("file?name=./timer-worker2.js!./core/services/data/timer-worker.js");

var smashClient = require("../src-client-lib/api/smash-client.js");
window.smashClient = new smashClient(window.smash.env.host, window.smash.env.vpn, onException, onReconnected);

import App from "./components/app.jsx";
import Login from "./components/auth/login.jsx";
import ForgotPassword from "./components/auth/forgotPassword.jsx";
import SignUp from "./components/auth/signUp.jsx";
import DataBank from "./components/data-bank/dataBank.jsx";
import Dashboard from "./components/dashboard/dashboard.jsx";
import AddWidget from "./components/dashboard/add-widget/addWidget.jsx";
import AnalyticStudio from "./components/analytic-studio/analyticStudio.jsx";
import Profile from "./components/profile/profile.jsx";
import Editor from "./components/analytic-studio/editor/editor.jsx";
import InternalEventBus from "./core/utils/internalEventBus";
import DashboardStandAlone from "./components/dashboard/dashboardStandalon.jsx";

function onException() {
  InternalEventBus.publish('solaceException');
}

function onReconnected() {
  InternalEventBus.publish('reconnected');
}

function requireAuth(nextState, replace, done) {
  if (!IdentityAccessService.isUserLoggedin()) {
    replace("/login");
    done();
  } else {
    done();
  }
}
render((
  <Router history={browserHistory}>

    <Route path="/" component={App} onEnter={requireAuth}>
      <IndexRoute component={DataBank}/>
      <Route path="/dashboard" component={Dashboard}/>
      <Route path="/addWidget" component={AddWidget}/>
      <Route path="/editWidget/:id" component={AddWidget}/>
      <Route path="/copyWidget/:id" component={AddWidget}/>
      <Route path="/analyticsStudio" component={AnalyticStudio}/>
      <Route path="/analyticsStudio/:id" component={Editor}/>
      <Route path="/profile" component={Profile}/>
    </Route>
    <Route path="/login" component={Login}/>
    <Route path="/signup" component={SignUp}/>
    <Route path="/forgot-password" component={ForgotPassword}/>
    <Route path="/d" component={DashboardStandAlone}/>
    <Route path="/candeal/:id" component={DashboardStandAlone}/>
    <Route path="*" component={Login}/>
  </Router>
), document.getElementById('smash'));



// WEBPACK FOOTER //
// ./src/index.js